import { ShippingMethod } from '../../../../../models/step-shipping/shipping-methods.js';

var ApplePayShippingTypes;
(function(ApplePayShippingTypes) {
    ApplePayShippingTypes["SHIPPING"] = 'shipping';
    ApplePayShippingTypes["DELIVERY"] = 'delivery';
    ApplePayShippingTypes["STORE_PICKUP_UP"] = 'storePickup';
    ApplePayShippingTypes["SERVICE_PICKUP"] = 'servicePickup';
})(ApplePayShippingTypes || (ApplePayShippingTypes = {}));
const mapper = {
    [ShippingMethod.Delivery]: ApplePayShippingTypes.DELIVERY,
    [ShippingMethod.DeliveryExpress]: ApplePayShippingTypes.DELIVERY,
    [ShippingMethod.Pickup]: ApplePayShippingTypes.STORE_PICKUP_UP,
    [ShippingMethod.PickupPoint]: ApplePayShippingTypes.SERVICE_PICKUP,
    [ShippingMethod.NearestPickup]: ApplePayShippingTypes.SERVICE_PICKUP
};
const mapGVShippingMethodToApplePayShippingType = (shippingMethod)=>mapper[shippingMethod]
;

export { ApplePayShippingTypes, mapGVShippingMethodToApplePayShippingType };
//# sourceMappingURL=apple-pay-shipping-types.js.map
